import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';

export class ContributionTier extends Model<Schemas['contributionTiers'], Models> {}
